import { render, staticRenderFns } from "./modalViewFechamento.vue?vue&type=template&id=5882eb0a"
import script from "./modalViewFechamento.vue?vue&type=script&lang=js"
export * from "./modalViewFechamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports